import { IOption } from '@/interfaces';

import { JobStatus, ProcessingStatus } from '@/features/regulatory-intake/enums';
import { getJobStatusLabel, getProcessingStatusLabel } from '@/features/regulatory-intake/utils';

export const PROCESSING_STATUS_OPTIONS: IOption[] = [
  {
    label: getProcessingStatusLabel(ProcessingStatus.Queued),
    value: ProcessingStatus.Queued.toString(),
  },
  {
    label: getProcessingStatusLabel(ProcessingStatus.Processing),
    value: ProcessingStatus.Processing.toString(),
  },
  {
    label: getProcessingStatusLabel(ProcessingStatus.Transferring),
    value: ProcessingStatus.Transferring.toString(),
  },
  {
    label: getProcessingStatusLabel(ProcessingStatus.Transferred),
    value: ProcessingStatus.Transferred.toString(),
  },
  {
    label: getProcessingStatusLabel(ProcessingStatus.Attention),
    value: ProcessingStatus.Attention.toString(),
  },
  {
    label: getProcessingStatusLabel(ProcessingStatus.Failed),
    value: ProcessingStatus.Failed.toString(),
  },
  {
    label: getProcessingStatusLabel(ProcessingStatus.NotAvailable),
    value: ProcessingStatus.NotAvailable.toString(),
  },
];

export const JOB_STATUS_OPTIONS: IOption[] = [
  {
    label: getJobStatusLabel(JobStatus.Running),
    value: JobStatus.Running.toString(),
  },
  {
    label: getJobStatusLabel(JobStatus.Completed),
    value: JobStatus.Completed.toString(),
  },
  {
    label: getJobStatusLabel(JobStatus.CompletedWithErrors),
    value: JobStatus.CompletedWithErrors.toString(),
  },
  {
    label: getJobStatusLabel(JobStatus.Failed),
    value: JobStatus.Failed.toString(),
  },
];

export const JOB_SCHEDULE_HOURS = [8, 14] as const; // 08:00 & 14:00 (Asia/Singapore)
